module.exports = __webpack_public_path__ + "static/media/undo-modal-icon.22108e69.svg";